import {ENV} from 'environments/environment';

export const CONSTANTS = {
    APP_NAME: "fira.bcn.ptne",
    AVAILABLE_LANGS: ['es', 'ca', 'en'],
    DEFAULT_LANG: 'es',
    DEFAULT_COUNTRY_ID: 209,
    LANG_ES: 'es_ES',
    LANG_CA: 'ca_ES',
    LANG_EN: 'en_GB',
    STATES: {
        EVENTS: '/events'
    },
    TRANSLATIONS_BY_DEFAULT_PATH: '/shows/cpa/literals/default/',
    TRANSLATIONS_PATH: '/shows/cpa/literals/',
    END_POINTS: {
        USERS: {
            VALIDATE_TICKET: '/login/validateTicket',
            USER: '/login/user',
            GET_USER_EVENTS: '/login/getUserEvents'
        },
    },
    MENU: [
      { url: '/users', name: 'MENU.USERS', icon: 'group' }
    ]
};

export const REQ = {
    NO_AUTH: [
        ENV.BASE_PATH.USERS + CONSTANTS.END_POINTS.USERS.VALIDATE_TICKET
    ]
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
